import React, {useEffect, useState} from "react";
import FlowContainer from "../../../PickProgram/FlowElements/FlowContainer";
import CmsHelper, {PickProgramPageHelper} from "../../../Utilities/CmsHelpers";
import {useCms} from "../../../../context/CmsContext";
import GoogleAnalytics from "../../../../analytics/GoogleAnalytics";
import AwsApiService from "../../../../services/AwsApiService";
import {useAccount} from "../../../../context/AccountContext";
import AccountsService from "../../../../services/AccountsService";
import {useNavigate} from "react-router-dom";
import GenericError from "../../../Utilities/GenericError";
import PopUp from "../../../Utilities/PopUp";
import {Link} from "@mui/material";
import UserService from "../../../../services/UserService";
import {Trans, useTranslation} from "react-i18next";
import usePaymentProvider from "../../../../services/PaymentProvider.ts";
import EvergentErrors from "../../../../services/Evergent/EvergentErrors.ts";
import {useAuth} from "../../../../context/AuthContext";
import {useProductFlowContext} from "../../../../context/ProductFlowContext";

export default function MigrationFlow({packages, couponExists, handleNextStep,
                                          contestSession,
                                          promoTargetDisplayName, promoRedirectURL,
                                          flow,
                                          cancellationFlow,
                                      token}) {
    const account = useAccount();
    const {authData} = useAuth();
    const {t} = useTranslation();
    const {pickProgramData} = useCms();
    const paymentProvider = usePaymentProvider();

    const navigate = useNavigate();

    const [products, setProducts] = useState([])

    const [unableToUpgrade, setUnableToUpgrade] = useState(false);
    const [actionUnableToUpgrade, setActionUnableToUpgrade] = useState(false);
    const [couponRedemptionError, setCouponRedemptionError] = useState(false);
    const [couponErrorCode, setCouponErrorCode] = useState(1000);

    const getPrice = (price) => {
        try {
            let res = price/100;
            if(!Number.isNaN(res))
                return res;
        } catch (e) {
        }
        return undefined;
    }

    const prepareAnalytics = ()=> {
        return AccountsService.getProfile().then(r => {
                console.log(r);
                let promotionId = r?.data?.couponsInformation?.[0]?.id;
                let promotionName = r?.data?.couponsInformation?.[0]?.name;

                let new_sku_name = !!r?.data?.subscription?.next_product_name ?
                                r?.data?.subscription?.next_product_name
                                :
                                r?.data?.subscription?.product?.name;

                let new_sku_id = !!r?.data?.subscription?.next_product_handle ?
                                r?.data?.subscription?.next_product_handle
                                :
                                r?.data?.subscription?.product?.product_price_point_handle;
                
                let new_product_attribute = !!r?.data?.subscription?.next_product_attribute ?
                                            r?.data?.subscription?.next_product_attribute
                                            :
                                            r?.data?.subscription?.productAttribute;
                
                let new_product_price_with_tax = !!r?.data?.subscription?.next_price_with_tax ?
                                                r?.data?.subscription?.next_price_with_tax
                                                :
                                                r?.data?.subscription?.product?.price_with_tax;
                const newProduct = {
                    skuName : new_sku_name,
                    skuId : new_sku_id,
                    prodAttribute: new_product_attribute,
                    promotionId: promotionId,
                    promotionName: promotionName,
                    price: getPrice(r?.data?.renewalPreview?.total_amount_due_in_cents),
                    priceWithTax: new_product_price_with_tax
                };
                account.setupAnalyticsEvProductConvertion(newProduct);
            });
    };


    useEffect(()=>{
        setLoading(true);
        let products;

        if(!!couponExists || !!token){
            products = packages ?? []
        }else{
            if(packages.displayName !== "Lite" && contestSession){
                handleNextStep();
                navigate("/CongratsPage")
                return;
            }
            products = [...packages.upgrades, ...(cancellationFlow ? [] : packages.downgrades)];
            products = products.filter(product => product.displayName !== "Lite"); //removes lite products from upgrade.

            if (!!promoTargetDisplayName) {
                const targetDisplayNames = JSON.parse(promoTargetDisplayName);
                products = products.filter(item1 => targetDisplayNames.some(item2 => item1.displayName === item2))
                if(products.length === 0){
                    window.open(promoRedirectURL, "_self")
                    return;
                }
            }
        }
        if(!!authData?.nextProductPricepoint){ //if scheduled product exists, filter it
            products = products.filter(program => program.pricePoint !== authData?.nextProductPricepoint)
        }

        if(products.length === 0){
            setUnableToUpgrade(true);
            account.clearSessionCoupon();
            setLoading(false);
            return;
        }

        setLoading(false);

        setProducts(products);

    }, [packages, couponExists, contestSession, promoTargetDisplayName, handleNextStep, promoRedirectURL]) //eslint-disable-line react-hooks/exhaustive-deps

    const { setOnNext, setSelectedProduct } = useProductFlowContext()

    const [loading, setLoading] = useState(false);
    const onNextAction = async (product, setError) =>{
        let addonEligible;
        if(!!product?.addons){
            addonEligible = product.addons;
            delete product.addons
        }

        let request = {
            pricePoint: product.pricePoint,
        };

        if(product.addonPricePoint){
            request = {
                ...request,
                addonPricePoint: product.addonPricePoint,
            }
        }

        if (!!couponExists) {
            if (packages[0].pricePoint === authData.pricePointHandle) {
                return AccountsService.addCoupon({couponCodes: [couponExists]})
                    .then(response => {
                        navigate("/CongratsPage");
                    })
                    .catch(e => {
                        let code = e?.response?.data?.code;
                        if (code) setCouponErrorCode(code);
                        setCouponRedemptionError(true);
                    })
                    .finally(()=>{
                        if (sessionStorage.getItem("discount-coupon")) {
                            sessionStorage.removeItem("discount-coupon");
                        }
                    });
            }
            else {
                request = {
                    ...request,
                    couponCode: couponExists,
                };
            }
        }

        if(!!product?.promotions){
            request = {
                ...request,
                promotionId: product?.promotions?.[0],
            };
        }

        account.setChosenProgramName(
            products.find((obj) => obj.productId === product.productId).name
        );
        GoogleAnalytics.onSelectPackage();
        AwsApiService.onPickProgram();


        sessionStorage.removeItem("selectedProgramId");

        return AccountsService.upgradeSubscription({...request, flow: flow})
            .then((response) => {
                if (sessionStorage.getItem("discount-coupon")) {
                    sessionStorage.removeItem("discount-coupon");
                }

                handleNextStep(true);
                window.addEventListener("message", function handleMessage(event){
                    console.debug(event)
                    const iframeUrl = new URL(response.data.uri);
                    if (!iframeUrl || (event.origin !== iframeUrl?.origin && event.origin !== window.location.origin)) {
                        return;
                    }

                    let data;
                    try {
                        data = JSON.parse(event.data);
                    }catch (e){
                        data = event.data;
                    }

                    if(data?.status !== undefined){
                        window.removeEventListener("message", handleMessage);
                        if((parseInt(data?.status) === 1)){
                            console.log("Successful flow, status: ", parseInt(data?.status))
                            handleNextStep(true);
                            if(!!couponExists){
                                sessionStorage.setItem("coupon-success", true)
                            }
                            if(data?.mlink){
                                sessionStorage.setItem("addon-mlink", JSON.stringify({
                                    mlink: data?.mlink,
                                    addon: addonEligible.find(addon => request.addonPricePoint === addon.skuORQuickCode)}))
                            }else{
                                if(!!addonEligible){
                                    sessionStorage.setItem("addon-eligible", JSON.stringify(addonEligible));
                                }
                            }
                            UserService.isSubscriptionAction()
                            prepareAnalytics().then(_ignore => navigate("/CongratsPage"));
                        } else if(parseInt(data.status) === 0){
                            if(data.errorCode === EvergentErrors.REQUEST_TERMINATED.value){
                                window.location.replace("/PickProgram"); //replace so user cant go back to /cartPage without any state
                            }
                        } else if(parseInt(data.status) === 400) {
                            window.removeEventListener("message", handleMessage);
                        }
                    }
                })
                navigate(paymentProvider.paymentForm, {state: {uri: response.data.uri}})
            })
            .catch((err) => {
                if(err.response.data.code === 303){
                    setActionUnableToUpgrade(true)
                }else{
                    //TODO handle error
                }
            });
    }


    const onNext = (product, setError) => {
        setLoading(true)
        onNextAction(product, setError)
            .finally(()=>{
                setLoading(false)
            });
    }

    return <>
        <FlowContainer packages={products}
                       loading={loading}
                       update={true}
                       currentProgram={!!packages?.displayName && !!packages?.productId ? {displayName: packages.displayName, productId: packages.productId} : undefined}
                       cancellationFlow={cancellationFlow}
                       couponExists={!!couponExists}
                       contestState={contestSession}
                       cmsData={PickProgramPageHelper.getPrograms(pickProgramData, cancellationFlow ? CmsHelper.CANCELLATION_MIGRATE : CmsHelper.UPGRADE_PROGRAM)}
                       onNext={onNext}
        />
        <PopUp
            openPopUp={unableToUpgrade}
            setOpenPopUp={(can)=>{setUnableToUpgrade(!can)}}
            maxWidth="md"
            showCloseButton={false}
            outlined={false}
            error={true}
            closeWhenClickedOutside={false}>
            <GenericError
                setClose={setUnableToUpgrade}
                buttonText={t("pickProgramUnableToUpgradeCTA")}
                executeFunction={function () {
                    window.open(`${process.env.REACT_APP_CONGRATS_BUTTON_LINK}`, "_self");
                }}
                mainText={t("pickProgramUnableToUpgradeHeader")}
                showIcon={false}>
                <span className={"pick-program-fallback-modal"}>
                    <Trans i18nKey="pickProgramUnableToUpgradeSecondary"
                            tOptions={{ interpolation: { escapeValue: false } }}
                            components={{
                                Link: <Link className="clickable" href={"https://help.antennaplus.gr/contact-us/"} target={"_blank"}/>
                            }}
                    />
                </span>
            </GenericError>
        </PopUp>
        <PopUp
            openPopUp={couponRedemptionError}
            setOpenPopUp={setCouponRedemptionError}
            maxWidth="md"
            fullWidth={true}
            showCloseButton={false}
            outlined={false}
            error={true}
            closeWhenClickedOutside={false}
        >
            <GenericError
                setClose={setCouponRedemptionError}
                success={false}
                // mainText={t("pickProgramCouponRedemptionErrorTitle")}
                buttonText={t("pickProgramCouponRedemptionErrorButton")}
                showIcon={true}
                executeFunction={() => navigate("/Account")}
            >
                <div className={"coupon-redemption-error-popup-wrapper"}>
                    <span className={"coupon-redemption-error-content"}>
                        {t(couponErrorCode)}
                    </span>
                </div>
            </GenericError>
        </PopUp>
        <PopUp
            openPopUp={actionUnableToUpgrade}
            setOpenPopUp={setActionUnableToUpgrade}
            maxWidth="md"
            fullWidth={true}
            showCloseButton={false}
            outlined={false}
            error={true}
            closeWhenClickedOutside={false}
        >
            <GenericError
                setClose={setActionUnableToUpgrade}
                success={false}
                buttonText={t("actionUnableToUpgradeAccountCTA")}
                showIcon={true}
                executeFunction={() => navigate("/Account")}
            >
                <div className={"coupon-redemption-error-popup-wrapper"}>
                    <span className={"coupon-redemption-error-content"}>
                        <Trans i18nKey="actionUnableToUpgradeAccountStatus"
                               tOptions={{interpolation: {escapeValue: false}}}
                               components={{
                                   Link: <Link className="clickable"
                                               href={"https://help.antennaplus.gr/contact-us/"}
                                               target={"_blank"}/>
                               }}
                        />
                    </span>
                </div>
            </GenericError>
        </PopUp>
    </>
}